module.exports = __webpack_public_path__ + "35ea0975a576615e0e83666af1093c6a.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.woff2?edd5f759e39cf0af8ed039b31ef6e852
// module id = 347
// module chunks = 0